// export const siteUrl = "http://127.0.0.1:8000/api"; // local backend
export const siteUrl = "https://navigo-dash-be-prod.herokuapp.com/api";
